import React from "react";
import { Button, HStack, Text } from "@commonsku/design-system";

export interface AutomationSaveBarProps {
  isDirty: boolean;
  saving: boolean;
  error: string | null;
  onSave: () => void;
  onCancel: () => void;
}

/**
 * Save/cancel controls for the automation editor header.
 */
const AutomationSaveBar = ({
  isDirty,
  saving,
  error,
  onSave,
  onCancel,
}: AutomationSaveBarProps) => {
  return (
    <HStack gap="4">
      {error && (
        <Text fontSize="sm" color="fg.critical" margin="0!">
          {error}
        </Text>
      )}
      <Button
        borderStyle="solid"
        variant="outline"
        onClick={onCancel}
        disabled={saving}
      >
        Cancel
      </Button>
      <Button onClick={onSave} disabled={!isDirty || saving} loading={saving}>
        Save
      </Button>
    </HStack>
  );
};

export default AutomationSaveBar;
